import Btn from '../utils/btn';

const func = $target => {

	var $btn = new Btn($target.find('button[type="submit"]'));

	$target.find('[name="qty"]').val(1);

	$target.on('submit', function(e) {

		//e.preventDefault();
		var $qty = $target.find('[name="qty"]'),
			$input = $(this).find('[name="purchasableId"]'),
			qty;

		if ($input[0].tagName == 'SELECT') {
			qty = $input.find('option:selected').data('qty');
		} else {
			qty = $input.filter(':checked').data('qty');
		}

		if (qty) {
			$qty.val(Number($qty.val()) * qty);
		} else {
			//$qty.val(1);
		}

		// disable btn
		$btn.process();

	});
};

export default func;